import * as React from "react";
import { forwardRef } from "react";
const SvgTabTimeline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 .35v4.174h4.174V.35Zm1.391 1.391h1.392v1.392H1.391Zm4.174 0v1.392H16V1.741ZM0 5.915v4.174h4.174V5.915Zm1.391 1.391h1.392v1.391H1.391Zm4.174 0v1.391H16v-1.39ZM0 11.48v4.17h4.174v-4.17Zm1.391 1.391h1.392v1.391H1.391Zm4.174 0v1.391H16v-1.39Z", className: "s20f2556d9695bd5488e1f6ea1f720191__b" }));
const ForwardRef = forwardRef(SvgTabTimeline);
export { ForwardRef as ReactComponent };
